import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Linkedin, Youtube, Send, ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A4F4C] text-stone-200 mt-24" data-testid="main-footer">
      <div className="pattern-band" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-1">
          <img
            src="https://customer-assets.emergentagent.com/job_demka-connect/artifacts/th3maqcx_DemkaBIZ_transp-01.png"
            alt="DemkaBiz"
            className="h-12 w-auto mb-4"
          />
          <p className="text-sm text-stone-300/80 max-w-xs leading-relaxed italic">
            « Les services d'établissement et d'entrepreneuriat en un seul clic. »
          </p>
          <p className="text-sm text-stone-300/70 max-w-xs leading-relaxed mt-3">
            La plateforme francophone qui accompagne les nouveaux arrivants et les entrepreneurs issus de l'immigration, de l'établissement au développement d'affaires au Canada.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="https://www.facebook.com/profile.php?id=61586812047133" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-accent hover:border-accent transition"><Facebook className="w-4 h-4" /></a>
            <a href="https://www.linkedin.com/company/109666147" target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-accent hover:border-accent transition"><Linkedin className="w-4 h-4" /></a>
            <a href="https://youtube.com/@DemkaGlobalMediaTV" target="_blank" rel="noreferrer" aria-label="Demka Global Média TV sur YouTube" data-testid="footer-youtube" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-accent hover:border-accent transition"><Youtube className="w-4 h-4" /></a>
            <a href="https://t.me/+9LcRsRIqlgRiNDIx" target="_blank" rel="noreferrer" aria-label="Telegram" data-testid="footer-telegram" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-accent hover:border-accent transition"><Send className="w-4 h-4" /></a>
          </div>
          <a
            href="https://t.me/+9LcRsRIqlgRiNDIx"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-telegram-community-cta"
            className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-full bg-accent/15 text-accent hover:bg-accent hover:text-white border border-accent/30 transition text-sm font-medium"
          >
            <Send className="w-4 h-4" />
            Rejoindre notre communauté Telegram
          </a>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Explorer</h4>
          <ul className="space-y-2 text-sm text-stone-400">
            <li><Link to="/je-metablis" className="hover:text-white">Je m'établis</Link></li>
            <li><Link to="/j-entreprends" className="hover:text-white">J'entreprends</Link></li>
            <li><Link to="/je-cherche-un-service" className="hover:text-white">Je cherche un service</Link></li>
            <li><Link to="/annuaire/professionnels" className="hover:text-white">Professionnels</Link></li>
            <li><Link to="/annuaire/entrepreneurs" className="hover:text-white">Entrepreneurs</Link></li>
            <li><Link to="/annuaire/organismes" className="hover:text-white">Organismes</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Médiathèque</h4>
          <ul className="space-y-2 text-sm text-stone-400">
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/agenda" className="hover:text-white">Événements & Agenda</Link></li>
            <li><Link to="/guide-pratique" className="hover:text-white">Guide pratique</Link></li>
            <li><Link to="/ressources-en-ligne" className="hover:text-white">Ressources en ligne</Link></li>
            <li><Link to="/ici-quebec" className="hover:text-white">Ici Québec</Link></li>
            <li><Link to="/a-propos" className="hover:text-white">À propos</Link></li>
            <li><Link to="/temoignages" className="hover:text-white">Témoignages</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/espace-ceda" className="hover:text-white">Espace CEDA</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Partenaires</h4>
          <ul className="space-y-2 text-sm text-stone-400">
            <li><a href="https://demkaglobalmedia.com" target="_blank" rel="noreferrer" className="hover:text-white inline-flex items-center gap-1">Demka Média <ExternalLink className="w-3 h-3" /></a></li>
            <li><Link to="/espace-publicite" className="hover:text-white">Espace publicité</Link></li>
            <li><Link to="/contact?sujet=partenariat" className="hover:text-white">Devenir partenaire</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link></li>
            <li><Link to="/confidentialite" className="hover:text-white">Confidentialité</Link></li>
            <li><Link to="/cookies" className="hover:text-white">Cookies</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-stone-400">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-accent flex-shrink-0" /> <span>20, boul. Charest Ouest, Bureau 102,<br/>Québec (Québec) G1K 1X2</span></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-accent" /> <a href="mailto:contact@demka.ca" className="hover:text-white">contact@demka.ca</a></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-accent" /> +1 (418) 473-5188</li>
            <li className="flex items-start gap-2 text-stone-400 text-xs pt-2"><MapPin className="w-3 h-3 mt-0.5 flex-shrink-0" /> <span>Point focal Afrique : Douala – Bonamoussadi, Cameroun · +237 682 52 18 95</span></li>
            <li className="text-stone-400 italic text-xs pt-2">Une initiative de Demka Services Inc.</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-500">
          <span>© {new Date().getFullYear()} DemkaBiz — Tous droits réservés.</span>
          <span className="italic">S'établir · Entreprendre · Réussir</span>
        </div>
      </div>
      <div className="pattern-band" />
    </footer>
  );
}
